import {FC} from 'react';
import {Button, styled, Tooltip, Typography} from '@mui/material';
import {colors} from '../../../../shared/colors';
import {useDeleteContractsCidDocumentId} from '../../../../global/services/documents/get-documents-doc-id-content.mutation';
import {resolveAndDownloadBlob} from '../../../../shared/helpers/resolveAndDownloadBlob';

interface Props {
  fileName?: string;
  documentId?: string;
}

export const ContractDataImportsDownloadButton: FC<Props> = ({fileName, documentId}) => {
  const {mutate} = useDeleteContractsCidDocumentId();

  if (!fileName) return null;

  const handleDownload = () => {
    if (!documentId) return;
    void mutate([documentId], async (res) => resolveAndDownloadBlob(res, fileName));
  };

  return (
    <StyledDownloadButton variant="text" onClick={handleDownload}>
      <Tooltip title={fileName}>
        <Typography textOverflow="ellipsis" noWrap variant="subtitle2">
          {fileName ?? '-'}
        </Typography>
      </Tooltip>
    </StyledDownloadButton>
  );
};

const StyledDownloadButton = styled(Button)({
  color: colors['icons--primary'],
  textDecoration: 'underline',
  textTransform: 'none',
});
